//@flow
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../../reducers/modal/modalActions';
import { TextButton } from 'texkit/dist/components/Buttons';
import { Trans } from '../../..';

const LicenseDetailModal = ({
  textFile = 'Labels',
  textId = 'HowToFindLicenseNumbers',
  fallback = 'How to find these numbers',
}) => {
  const dispatch = useDispatch();

  return (
    <TextButton
      icon="info"
      onClick={event => {
        event.preventDefault();
        dispatch(openModal('LicenseDetailsModal'));
      }}
      type="button"
    >
      <Trans file={textFile} id={textId} fallback={fallback} />{' '}
    </TextButton>
  );
};

LicenseDetailModal.propTypes = {
  textFile: PropTypes.string,
  textId: PropTypes.string,
  fallback: PropTypes.string,
};

export default LicenseDetailModal;
